import {
    Circle,
    DataCard,
    HorizontalScroll,
    IconLandlineRegular,
    IconMultideviceRegular,
    IconOpticalFiberRegular,
    IconTvContentRegular,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React from 'react';
import './index.scss';
import { Badge } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import { useDispatch } from 'react-redux';
import { showStopper } from '../../utils/store/features/user';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import { Device } from '../../models/Devices';
import { globalEvents, triggerGlobalEvent } from '../../utils/dataTransformation/GlobalEvents';
import { useDevicesContext } from '../../context/devices-context/DevicesContext';

export interface OttServices {
    netflix: boolean;
    disney: boolean;
}

export interface OtherServicesSectionData {
    dataTab: any;
    BillingCycle?: any;
    closing?: any;
    devices?: Device[];
    ott?: OttServices;
}

const OtherServicesSection: React.FC<OtherServicesSectionData> = ({
    dataTab,
    BillingCycle,
    closing,
    devices,
    ott,
}: OtherServicesSectionData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const consumptionsDisabled = managementEnvironment().VITE_STOPPER_CONSUMPTIONS_DISABLED;
    const size = useWindowSize();
    const { setDevices } = useDevicesContext();

    const sendToNative = (url: string) => {
        if (url === '/phone') {
            if (consumptionsDisabled) {
                dispatch(showStopper());
            } else {
                const dataTabStorage = dataTab;
                dataTabStorage.BillingCycle = BillingCycle;
                dataTabStorage.closing = closing;
                localStorage.setItem('storage', JSON.stringify(dataTabStorage));
                navigate(url + '?productPsId=' + dataTab.productPsId);
            }
        } else if (url === '/fiber') {
            const dataTabStorage = dataTab;
            dataTabStorage.BillingCycle = BillingCycle;
            dataTabStorage.closing = closing;
            navigate(url + '?productId=' + dataTab.productId);
        } else if (url === '/devices') {
            setDevices(devices || []);
            navigate(url);
        }
    };

    return (
        <div className='other-services-section'>
            <div className='other-services-section__cards'>
                <HorizontalScroll>
                    <div
                        className='other-services-section__cards-container'
                        style={{ width: devices ? (size.width >= 768 ? '100%' : 'auto') : '100%' }}
                    >
                        <div
                            className='other-services-section__cards-container__card'
                            style={{
                                width: devices
                                    ? size.width >= 1024
                                        ? '100%'
                                        : size.width >= 768
                                          ? '100%'
                                          : '152px'
                                    : '100%',
                            }}
                            onClick={() => sendToNative('/fiber')}
                        >
                            <DataCard
                                size='snap'
                                asset={
                                    <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                        <IconOpticalFiberRegular color={skinVars.colors.brand} size={24} />
                                    </Circle>
                                }
                                title={t('fiber')}
                            ></DataCard>
                        </div>
                        {(ott?.netflix || ott?.disney) && (
                            <div
                                className='other-services-section__cards-container__card'
                                style={{
                                    width: devices
                                        ? size.width >= 1024
                                            ? '100%'
                                            : size.width >= 768
                                              ? '100%'
                                              : '152px'
                                        : '100%',
                                }}
                                onClick={() => triggerGlobalEvent(globalEvents.entertainment)}
                            >
                                <DataCard
                                    size='snap'
                                    asset={
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <IconTvContentRegular color={skinVars.colors.brand} size={24} />
                                        </Circle>
                                    }
                                    title={t('Entertainment')}
                                ></DataCard>
                            </div>
                        )}
                        {devices?.length! > 0 && (
                            <div
                                className='other-services-section__cards-container__card'
                                style={{
                                    width: devices
                                        ? size.width >= 1024
                                            ? '100%'
                                            : size.width >= 768
                                              ? '100%'
                                              : '152px'
                                        : '100%',
                                }}
                                onClick={() => sendToNative('/devices')}
                            >
                                <DataCard
                                    size='snap'
                                    asset={
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <IconMultideviceRegular color={skinVars.colors.brand} size={24} />
                                        </Circle>
                                    }
                                    title={t('devicesExplore')}
                                ></DataCard>
                            </div>
                        )}
                        <div
                            className='other-services-section__cards-container__card'
                            style={{
                                width: devices
                                    ? size.width >= 1024
                                        ? '100%'
                                        : size.width >= 768
                                          ? '100%'
                                          : '152px'
                                    : '100%',
                            }}
                            onClick={() => sendToNative('/phone')}
                        >
                            <DataCard
                                size='snap'
                                asset={
                                    <div>
                                        <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                            <div className='other-services-section__cards-container__card-circle'>
                                                {dataTab.extraSum > 0 && (
                                                    <div className='other-services-section__cards-container__card-circle-badge'>
                                                        <Badge></Badge>
                                                    </div>
                                                )}
                                                <IconLandlineRegular color={skinVars.colors.brand} size={24} />
                                            </div>
                                        </Circle>
                                    </div>
                                }
                                title={t('permanent')}
                            ></DataCard>
                        </div>
                    </div>
                </HorizontalScroll>
            </div>
        </div>
    );
};

export default OtherServicesSection;
